/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useSelector } from "react-redux";

// eslint-disable-next-line import/no-unresolved
import { VerifyUserInfoDialog } from "@regional/components";
import SubLicenseEditDialog from "./SubLicenseEdit";

function FormRecordEditDialog(props) {
  const { show, type } = useSelector(
    (state) => state.dialogFormProps?.actionPanel || {}
  );

  if (!show) return null;
  if (type === "userInfoEdit" && VerifyUserInfoDialog)
    return <VerifyUserInfoDialog {...props} />;
  if (type === "subLicenseEdit") return <SubLicenseEditDialog {...props} />;
  return null;
}

export default FormRecordEditDialog;
